import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  logo: null,
  siteData: null,
};
const websiteSlice = createSlice({
  name: "website",
  initialState: initialState,
  reducers: {
    setLogo: (state, action) => {
      state.logo = action.payload;
    },
    setSiteData: (state, action) => {
      state.siteData = action.payload;
    },
  },
});
export const { setLogo, setSiteData } = websiteSlice.actions;
export default websiteSlice.reducer;
